<div class="bulk-members-container">
  <!-- Toast para notificaciones -->
  <p-toast position="top-right"></p-toast>

  <!-- Header Section -->
  <div class="header-section">
    <h1 class="page-title">Administración Masiva de Miembros</h1>
    <p class="page-description">
      Esta sección permite ejecutar operaciones masivas sobre los miembros de los clubes del sistema.
      <strong>Solo disponible para administradores SID.</strong>
    </p>
  </div>

  <p-tabView>
    <!-- ===================================================================
         SECCIÓN 1: Desactivación masiva
         =================================================================== -->
    <p-tabPanel header="Desactivación Masiva" leftIcon="pi pi-ban">
      <!-- Warning Alert -->
      <p-messages severity="warn" styleClass="warning-alert">
        <ng-template pTemplate>
          <div class="message-content">
            <strong>ATENCIÓN: Operación Crítica del Sistema</strong>
            <p>Esta operación afectará a <strong>TODOS</strong> los miembros de <strong>TODOS</strong> los clubes registrados en el sistema.</p>
            <p>Utilice esta función con extrema precaución. Se recomienda realizar respaldos antes de ejecutar operaciones masivas.</p>
          </div>
        </ng-template>
      </p-messages>

      <!-- Main Content Card -->
      <p-card styleClass="content-card">
        <div class="form-section">
          <!-- Year Filter -->
          <div class="filter-group">
            <label class="filter-label">
              <i class="pi pi-calendar"></i>
              Filtrar por Año (Opcional)
            </label>
            <p-dropdown
              [(ngModel)]="yearFilter"
              [options]="yearsList"
              placeholder="Seleccione un año"
              styleClass="year-select"
              [showClear]="true"
            />
            <p class="filter-hint">
              Si no selecciona un año, se desactivarán miembros de todos los años.
            </p>
          </div>

          <!-- Information Section -->
          <p-card styleClass="info-card">
            <h3 class="info-title">
              <i class="pi pi-info-circle"></i>
              Información de la Operación
            </h3>
            <ul class="info-list">
              <li>Acción: <strong>Desactivar todos los miembros</strong></li>
              <li>Alcance: <strong>Todos los clubes del sistema</strong></li>
              <li>Año: <strong>{{ yearFilter || 'Todos los años' }}</strong></li>
              <li>Reversible: <strong>Sí, mediante activación manual individual</strong></li>
            </ul>
          </p-card>

          <!-- Action Button -->
          <div class="action-section">
            <p-button
              label="Desactivar Todos los Miembros"
              icon="pi pi-exclamation-triangle"
              severity="danger"
              size="large"
              styleClass="deactivate-button"
              (onClick)="showDeactivateAllModal()"
            />
          </div>
        </div>
      </p-card>
    </p-tabPanel>

    <!-- ===================================================================
         SECCIÓN 2: Reactivación de Escuelas
         =================================================================== -->
    <p-tabPanel header="Reactivación de Escuelas" leftIcon="pi pi-refresh">
      <p-messages severity="info" styleClass="warning-alert">
        <ng-template pTemplate>
          <div class="message-content">
            <strong>Reactivación masiva de miembros de Escuela (Externos)</strong>
            <p>Esta operación reactivará (<strong>isActive = true</strong>) únicamente a los miembros cuyo nivel sea <strong>ESCUELA</strong> y cuyo tipo sea <strong>EXTERNAL</strong>.</p>
            <p>Aplica a todos los clubes del sistema. Use el filtro de año para limitar el alcance.</p>
          </div>
        </ng-template>
      </p-messages>

      <p-card styleClass="content-card">
        <div class="form-section">
          <div class="filter-group">
            <label class="filter-label">
              <i class="pi pi-calendar"></i>
              Filtrar por Año (Opcional)
            </label>
            <p-dropdown
              [(ngModel)]="reactivateYearFilter"
              [options]="yearsList"
              placeholder="Seleccione un año"
              styleClass="year-select"
              [showClear]="true"
            />
            <p class="filter-hint">
              Si no selecciona un año, se reactivarán miembros ESCUELA / EXTERNAL de todos los años.
            </p>
          </div>

          <p-card styleClass="info-card">
            <h3 class="info-title">
              <i class="pi pi-info-circle"></i>
              Información de la Operación
            </h3>
            <ul class="info-list">
              <li>Acción: <strong>Activar miembros (isActive = true)</strong></li>
              <li>Filtro nivel: <strong>ESCUELA</strong></li>
              <li>Filtro tipo: <strong>EXTERNAL</strong></li>
              <li>Alcance: <strong>Todos los clubes del sistema</strong></li>
              <li>Año: <strong>{{ reactivateYearFilter || 'Todos los años' }}</strong></li>
            </ul>
          </p-card>

          <div class="action-section">
            <p-button
              label="Reactivar Escuelas"
              icon="pi pi-refresh"
              severity="success"
              size="large"
              styleClass="deactivate-button"
              (onClick)="showReactivateSchoolsModal()"
            />
          </div>
        </div>
      </p-card>
    </p-tabPanel>
  </p-tabView>

  <!-- ===================================================================
       Modales (compartidos por ambas operaciones)
       =================================================================== -->

  <!-- First Confirmation Modal -->
  <p-dialog
    [(visible)]="showConfirmModal"
    [header]="isReactivateOperation() ? 'Confirmación: Reactivación de Escuelas' : '⚠️ ADVERTENCIA: Operación Crítica'"
    [modal]="true"
    [closable]="false"
    [dismissableMask]="false"
    [style]="{ width: '600px' }"
    styleClass="confirmation-modal"
  >
    <ng-template pTemplate="content">
      <!-- Critical Warning -->
      <p-messages [severity]="isReactivateOperation() ? 'info' : 'error'" styleClass="modal-alert">
        <ng-template pTemplate>
          <div class="message-content" *ngIf="!isReactivateOperation()">
            <strong>ACCIÓN IRREVERSIBLE A GRAN ESCALA</strong>
            <p>Esta operación desactivará <strong>PERMANENTEMENTE</strong> todos los miembros del sistema.</p>
            <p>Los miembros desactivados deberán ser reactivados manualmente uno por uno.</p>
          </div>
          <div class="message-content" *ngIf="isReactivateOperation()">
            <strong>OPERACIÓN MASIVA DE REACTIVACIÓN</strong>
            <p>Esta operación activará (<strong>isActive = true</strong>) a todos los miembros con nivel <strong>ESCUELA</strong> y tipo <strong>EXTERNAL</strong>.</p>
          </div>
        </ng-template>
      </p-messages>

      <!-- Operation Details -->
      <div class="operation-details">
        <h4>Detalles de la Operación:</h4>
        <ul *ngIf="!isReactivateOperation()">
          <li><strong>Clubes afectados:</strong> Todos los clubes del sistema</li>
          <li><strong>Miembros afectados:</strong> Todos los miembros{{ yearFilter ? ' del año ' + yearFilter : ' de todos los años' }}</li>
          <li><strong>Efecto:</strong> Los miembros pasarán a estado inactivo</li>
          <li><strong>Usuario ejecutante:</strong> {{ getUserEmail() }}</li>
          <li><strong>Fecha y hora:</strong> {{ getCurrentDateTime() }}</li>
        </ul>
        <ul *ngIf="isReactivateOperation()">
          <li><strong>Clubes afectados:</strong> Todos los clubes del sistema</li>
          <li><strong>Filtro nivel:</strong> ESCUELA</li>
          <li><strong>Filtro tipo:</strong> EXTERNAL</li>
          <li><strong>Año:</strong> {{ reactivateYearFilter || 'Todos los años' }}</li>
          <li><strong>Efecto:</strong> Los miembros pasarán a estado activo</li>
          <li><strong>Usuario ejecutante:</strong> {{ getUserEmail() }}</li>
          <li><strong>Fecha y hora:</strong> {{ getCurrentDateTime() }}</li>
        </ul>
      </div>

      <!-- Confirmation Input -->
      <div class="confirmation-section">
        <h4 class="confirmation-title">Para continuar, escriba exactamente:</h4>
        <div class="required-text">{{ requiredConfirmationText }}</div>
        <input
          pInputText
          type="text"
          [(ngModel)]="confirmationText"
          placeholder="Escriba el texto aquí"
          class="confirmation-input"
          (keyup.enter)="!isConfirmButtonDisabled() && confirmDeactivateAll()"
        />
        <p class="confirmation-hint" *ngIf="confirmationText && confirmationText !== requiredConfirmationText">
          <i class="pi pi-times-circle error-icon"></i>
          El texto no coincide. Debe ser exactamente: "{{ requiredConfirmationText }}"
        </p>
        <p class="confirmation-success" *ngIf="confirmationText === requiredConfirmationText">
          <i class="pi pi-check-circle success-icon"></i>
          Texto correcto. Puede proceder con la confirmación.
        </p>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        severity="secondary"
        (onClick)="cancelOperation()"
      />
      <p-button
        [label]="isReactivateOperation() ? 'Confirmar Reactivación' : 'Confirmar Desactivación'"
        [icon]="isReactivateOperation() ? 'pi pi-refresh' : 'pi pi-exclamation-triangle'"
        [severity]="isReactivateOperation() ? 'success' : 'danger'"
        [disabled]="isConfirmButtonDisabled()"
        (onClick)="confirmDeactivateAll()"
      />
    </ng-template>
  </p-dialog>

  <!-- Second Confirmation Modal -->
  <p-dialog
    [(visible)]="showSecondConfirmModal"
    header="⚠️ CONFIRMACIÓN FINAL"
    [modal]="true"
    [closable]="false"
    [dismissableMask]="false"
    [style]="{ width: '500px' }"
    styleClass="confirmation-modal"
  >
    <ng-template pTemplate="content">
      <div class="final-confirmation" *ngIf="!isReactivateOperation()">
        <p class="final-warning">
          <strong>ÚLTIMA ADVERTENCIA:</strong>
        </p>
        <p>Esta acción desactivará <strong>TODOS</strong> los miembros de <strong>TODOS</strong> los clubes{{ yearFilter ? ' del año ' + yearFilter : '' }}.</p>
        <p>¿Estás absolutamente seguro?</p>
      </div>
      <div class="final-confirmation" *ngIf="isReactivateOperation()">
        <p class="final-warning">
          <strong>Confirmación final:</strong>
        </p>
        <p>Esta acción reactivará a los miembros con nivel <strong>ESCUELA</strong> y tipo <strong>EXTERNAL</strong>{{ reactivateYearFilter ? ' del año ' + reactivateYearFilter : ' de todos los años' }}.</p>
        <p>¿Deseas continuar?</p>
      </div>
    </ng-template>

    <ng-template pTemplate="footer">
      <p-button
        label="Cancelar"
        icon="pi pi-times"
        severity="secondary"
        (onClick)="cancelOperation()"
      />
      <p-button
        [label]="isReactivateOperation() ? 'Sí, Reactivar Escuelas' : 'Sí, Desactivar Todos'"
        [icon]="isReactivateOperation() ? 'pi pi-refresh' : 'pi pi-exclamation-triangle'"
        [severity]="isReactivateOperation() ? 'success' : 'danger'"
        (onClick)="executeBulkOperation()"
      />
    </ng-template>
  </p-dialog>

  <!-- Progress Dialog -->
  <p-dialog
    [(visible)]="showProgressDialog"
    header="Procesando Actualización Masiva"
    [modal]="true"
    [closable]="false"
    [dismissableMask]="false"
    [style]="{ width: '500px' }"
    styleClass="progress-dialog"
  >
    <ng-template pTemplate="content">
      <div class="progress-content">
        <div class="status-message">
          {{ getStatusMessage() }}
        </div>

        <p-progressBar
          [value]="getProgressPercentage()"
          [showValue]="true"
          styleClass="progress-bar-custom"
        ></p-progressBar>

        <div class="progress-details" *ngIf="jobStatus && jobStatus.progress">
          <div class="detail-row">
            <span class="detail-label">Total:</span>
            <span class="detail-value">{{ jobStatus.progress.total }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Procesados:</span>
            <span class="detail-value">{{ jobStatus.progress.processed }}</span>
          </div>
          <div class="detail-row success">
            <span class="detail-label">Exitosos:</span>
            <span class="detail-value">{{ jobStatus.progress.successful }}</span>
          </div>
          <div class="detail-row error" *ngIf="jobStatus.progress.failed > 0">
            <span class="detail-label">Errores:</span>
            <span class="detail-value">{{ jobStatus.progress.failed }}</span>
          </div>
        </div>

        <div class="spinner-container" *ngIf="jobStatus?.status === 'processing'">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: var(--primary-color);"></i>
        </div>
      </div>
    </ng-template>
  </p-dialog>
</div>
